export const WEB_APP_FULL_SCREEN_ROUTES = [
  "/admin/:communityId/events/drafts/:id",
] as const;
